// extracted by mini-css-extract-plugin
module.exports = {"form":"inputFieldDialog_form__ud9wm","fields":"inputFieldDialog_fields__wTWF7"};